import AnnotationBadge from "atoms/badges/annotation-badge";
import { ImageAnnotationRecord } from "models/view-models/block-configurations/image-annotation-record";
import React from "react";

const ImageAnnotation: React.FC<{
    annotation: ImageAnnotationRecord;
    number: number;
    canDrag: boolean;
    onClick?: (annotation: ImageAnnotationRecord) => void;
    onMoveStart?: (annotation: ImageAnnotationRecord) => void;
    visible: boolean;
    printable?: boolean;
}> = ({
    annotation,
    number,
    canDrag,
    onMoveStart,
    onClick,
    visible,
    printable,
}) => {
    const handleDragStart = () => {
        onMoveStart && onMoveStart(annotation);
    };
    const handleClick = () => {
        if (printable) {
            return;
        }
        onClick && onClick(annotation);
    };
    const cssPrintableClass = printable ? " -printable" : "";
    const cssLoadedClass = visible ? " -loaded" : "";
    return (
        <div
            onClick={handleClick}
            onDragStart={handleDragStart}
            draggable={canDrag}
            className={`c-image-annotation ${cssLoadedClass} ${cssPrintableClass}`}
            style={annotation.toInlineStyles()}>
            <AnnotationBadge number={number} />
        </div>
    );
};

export default ImageAnnotation;
